module.exports = __webpack_public_path__ + "img/174.37cd2259.jpg";